import { connect } from 'react-redux';

import { setLogs } from '../actions';
import { getLogs } from '../actionsSagas';
import { getCurrentLogs, getWaiting } from '../selectors';
import ViewActivityModal from './ViewActivityModal';

const mapStateToProps = (state, ownProps) => ({
  closeModal: ownProps.closeModal,
  id: ownProps.id,
  isChapter: ownProps.isChapter,
  logs: getCurrentLogs(state),
  waiting: getWaiting(state),
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (id, isChapter) => {
    dispatch(getLogs(id, isChapter));
  },
  setLogs: () => {
    dispatch(setLogs([]));
  },
});

const ViewActivityContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewActivityModal);

export default ViewActivityContainer;
